import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";


// importar por seccion (namespace)
import common_en from "./locales/en/common.json";
import home_en from "./locales/en/home.json";
import pitch_start_en from "./locales/en/pitch_start.json";
import pitch_en from "./locales/en/pitch.json";
import verify_en from "./locales/en/verify.json";
import login_en from "./locales/en/login.json";
import navbar_en from "./locales/en/navbar.json";
import signup_en from "./locales/en/signup.json";
import forgot_en from "./locales/en/forgot.json";
import reset_en from "./locales/en/reset.json";
import profile_en from "./locales/en/profile.json";
import footer_en from "./locales/en/footer.json";
import contact_en from "./locales/en/contact.json";
import legal_en from "./locales/en/legal.json";
import evaluation_en from "./locales/en/evaluation.json";
import dashboard_en from "./locales/en/dashboard.json";
import sessions_en from "./locales/en/sessions.json";
import achievements_en from "./locales/en/achievements.json";
import coach_suggestion_en from "./locales/en/coach_suggestion.json";
import pricing_en from "./locales/en/pricing.json";
import checkout_en from "./locales/en/checkout.json";
import billing_en from "./locales/en/billing.json";
import mainmenu_en from "./locales/en/mainmenu.json";
import faqs_en from "./locales/en/faqs.json";
import early_pitchers_en from "./locales/en/early_pitchers.json";

import common_es from "./locales/es/common.json";
import home_es from "./locales/es/home.json";
import pitch_start_es from "./locales/es/pitch_start.json";
import pitch_es from "./locales/es/pitch.json";
import verify_es from "./locales/es/verify.json";
import login_es from "./locales/es/login.json";
import navbar_es from "./locales/es/navbar.json";
import signup_es from "./locales/es/signup.json";
import forgot_es from "./locales/es/forgot.json";
import reset_es from "./locales/es/reset.json";
import profile_es from "./locales/es/profile.json";
import footer_es from "./locales/es/footer.json";
import contact_es from "./locales/es/contact.json";
import legal_es from "./locales/es/legal.json";
import evaluation_es from "./locales/es/evaluation.json";
import dashboard_es from "./locales/es/dashboard.json";
import sessions_es from "./locales/es/sessions.json";
import achievements_es from "./locales/es/achievements.json";
import coach_suggestion_es from "./locales/es/coach_suggestion.json";
import pricing_es from "./locales/es/pricing.json";
import checkout_es from "./locales/es/checkout.json";
import billing_es from "./locales/es/billing.json";
import mainmenu_es from "./locales/es/mainmenu.json";
import faqs_es from "./locales/es/faqs.json";
import early_pitchers_es from "./locales/es/early_pitchers.json";

// i18n
//   .use(LanguageDetector) // Detects browser language
//   .use(initReactI18next) // Initializes React binding
//   .init({
//     resources: {
//       en: { translation: en },
//       es: { translation: es }
//     },
//     fallbackLng: "en", // Default to English if language not found
//     interpolation: {
//       escapeValue: false
//     }
//   });

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: common_en,
        home: home_en,
        pitch_start: pitch_start_en,
        pitch: pitch_en,
        verify: verify_en,
        login: login_en,
        navbar: navbar_en,
        signup: signup_en,
        forgot: forgot_en,
        reset: reset_en,
        profile: profile_en,
        footer: footer_en,
        contact: contact_en,
        legal: legal_en,
        evaluation: evaluation_en,
        dashboard: dashboard_en,
        sessions: sessions_en,
        achievements: achievements_en,
        coach_suggestion: coach_suggestion_en,
        pricing: pricing_en,
        checkout: checkout_en,
        billing: billing_en,
        mainmenu: mainmenu_en,
        faqs: faqs_en,
        early_pitchers: early_pitchers_en,
      },
      es: {
        common: common_es,
        home: home_es,
        pitch_start: pitch_start_es,
        pitch: pitch_es,
        verify: verify_es,
        login: login_es,
        navbar: navbar_es,
        signup: signup_es,
        forgot: forgot_es,
        reset: reset_es,
        profile: profile_es,
        footer: footer_es,
        contact: contact_es,
        legal: legal_es,
        evaluation: evaluation_es,
        dashboard: dashboard_es,
        sessions: sessions_es,
        achievements: achievements_es,
        coach_suggestion: coach_suggestion_es,
        pricing: pricing_es,
        checkout: checkout_es,
        billing: billing_es,
        mainmenu: mainmenu_es,
        faqs: faqs_es,
        early_pitchers: early_pitchers_es,
      },
    },
    fallbackLng: "en",
    ns: ["common", "home", "pitch", "verify", "login", "navbar", "signup", "forgot", "reset", "profile", "footer", "contact",
          "legal", "dashboard", "sessions", "evaluation", "achievements", "coach_suggestion", "pricing", "checkout", "billing",
          "mainmenu", "faqs", "early_pitchers"],  // Namespaces disponibles
    defaultNS: "common",              // Namespace por defecto
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
